
/**
 * Asynchronously copies text to the clipboard.
 * @param {string} text - The text to copy to the clipboard.
 * @returns {Promise<boolean>} A promise that resolves to true if the text was successfully copied, false otherwise.
 */
export const copyToClipboard = async (text) =>{
    return navigator.clipboard
    .writeText(text)
}

/**
 * Convierte un objeto en un string de parámetros para usar en una solicitud fetch.
 * @param {Record<string, any> | undefined} objeto - El objeto con los parámetros (opcional).
 * @param {string | undefined} [textFilter] - El valor para el parámetro 'all' (opcional).
 * @returns {string} El string de parámetros.
 */
export function objetoAParametrosFetch(objeto:any, textFilter:string|undefined, textFilterFieldName:string="search"):string {
    const parametros = new URLSearchParams();
  
    // Verificar si el objeto no es undefined ni null y no está vacío
    if (objeto && Object.keys(objeto).length > 0) {
      for (const key in objeto) {
        parametros.append(key, objeto[key]);
      }
    }
  
    // Agregar textFilter si está presente
    if (textFilter) {
      parametros.append(textFilterFieldName, textFilter);
    }

  
    return parametros.toString();
  }